/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./range')} */
module.exports = RangeError;

